import microuniversoApi from "app/api/microuniversoApi"
import store from "app/redux/store/store"
import { DataFormatoEN } from "app/types/DataFormatoEN"
import { WindowMU } from "app/types/WindowMU"
import globalMU from "globalMU"

declare var window:WindowMU

export type AlterarDataPrevisaoEntregaItens =  {
    identificadoresItens: number[]
    dataPrevisaoEntrega: DataFormatoEN
}

export async function alterarDataPrevisaoEntregaItens(input: AlterarDataPrevisaoEntregaItens) {
    try {
        globalMU.blockUI()
        
        const orcamentoAtualizado = await microuniversoApi.Orcamento.definirDataPrevisaoEntregaItensOrcamento(
            store.getState().orcamento.IdentificadorOrcamento,
            input.identificadoresItens,
            input.dataPrevisaoEntrega)

        if ("HasErrors" in orcamentoAtualizado) {
            return
        }

        window.orcamentoController.model.atualizar(orcamentoAtualizado,true,true,true)

            
    } finally {
        globalMU.unblockUI()
    }
}